// extracted by mini-css-extract-plugin
export default {"DeviceButton":"DevicesListItem_DeviceButton__uq2B4","DeleteContainer":"DevicesListItem_DeleteContainer__FQZfU"};